module.exports = __webpack_public_path__ + "img/dashiji-2005.406169e2.jpg";